import { Barcode } from 'browser/components/atomic-elements/atoms/barcode/barcode'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const BarcodeField = LabelFieldFactory({ InputComponent: Barcode })
export { BarcodeField }
